import { jsx as _jsx } from "react/jsx-runtime";
import noop from 'hs-lodash/noop';
import { useRef } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { useTracker } from '../tracking/useTracker';
import { StyledGoogleIdentityServicesLoading, StyledGoogleOAuthButton } from './GoogleOAuthButton.styles.ts';
import { useGoogleIdentityServices } from './useGoogleIdentityServices';
import { useGoogleLoginNonce } from './useGoogleLoginNonce';
import { useLoadGoogleIdentityServices } from './useLoadGoogleIdentityServices';
export const GoogleOAuthButton = ({
  onAuthenticationStarted = noop,
  onAuthenticationSucceeded = noop,
  onVerificationFailed = noop,
  onVerificationStarted = noop,
  onVerificationSucceeded = noop
}) => {
  const googleButtonRef = useRef(null);
  const googleSignInNonce = useGoogleLoginNonce();
  const Tracker = useTracker();

  const onAuthenticationFailed = failure => Tracker.signupInteraction(`google-oauth-exception-${failure.reason}`);

  const {
    isLoading,
    isLoaded
  } = useLoadGoogleIdentityServices({
    onAuthenticationFailed
  });
  const {
    APP_DIMS
  } = useResponsiveness();
  const isGoogleLibraryLoaded = !isLoading || isLoaded;
  useGoogleIdentityServices({
    googleButtonRef,
    libraryHasLoaded: isGoogleLibraryLoaded,
    googleSignInNonce,
    onAuthenticationStarted,
    onAuthenticationSucceeded,
    onVerificationStarted,
    onVerificationSucceeded,
    onVerificationFailed
  });
  return /*#__PURE__*/_jsx(StyledGoogleOAuthButton, {
    className: "GoogleIdentityServicesButton",
    id: "g_id_onload",
    ref: googleButtonRef,
    children: isGoogleLibraryLoaded && /*#__PURE__*/_jsx(StyledGoogleIdentityServicesLoading, {
      className: "GoogleIdentityServicesLoading",
      style: {
        width: `${APP_DIMS.button.googleButtonWidth}px`
      },
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true,
        layout: "centered",
        size: "extra-small"
      })
    })
  });
};